import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 7.2a4 4 0 0 1 4 4V16H4v-4.8a4 4 0 0 1 4-4M2.63 9.605q-.19.647-.224 1.32L2.4 11.2V16H0v-3.6a2.8 2.8 0 0 1 2.495-2.784l.136-.011m10.74 0A2.8 2.8 0 0 1 16 12.4V16h-2.4v-4.8c0-.554-.08-1.09-.23-1.595M2.8 4.8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m10.4 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4M8 0a3.2 3.2 0 1 1 0 6.4A3.2 3.2 0 0 1 8 0"
    }, null, -1)
  ])))
}
export default { render: render }